
<div class="card text-decoration-none bg-emphasis bg-opacity-25" *ngIf="c" [style.min-height.px]="c?.minHeight">
  <div class="card-body align-items-center text m-5px" *ngIf="widget">
    
    <div class="d-flex fw-bold small text-truncate text-uppercase" *ngIf="widget.name">
      <span class="flex-grow-1">{{widget.name}}</span>
    </div>

    <div class="row control-row" *ngFor="let ts of c.detailList">
      <hr>
      <div class="col-lg-12" *ngIf="ts.controlType == '0'">
        <div class="form-check form-switch">
          <input type="checkbox" class="form-check-input" id="switch">
          <label class="form-check-label" for="switch">{{ts.displayName}}</label>
        </div>
      </div>

      <div class="col-lg-12" *ngIf="ts.controlType == '1'">
        <button class="btn btn-xs btn-block btn-outline-theme" (click)="executeButton(ts)">{{ts.displayName}}</button>
      </div>

      <div class="col-lg-12" *ngIf="ts.controlType == '2'">
        <div class="form-group mb-3">
          <label for="formControlRange" class="form-label">{{ts.displayName}}</label>
          <input type="range" class="form-range" id="formControlRange" [min]="ts.sliderMin" [max]="ts.sliderMax" [step]="ts.sliderStep">
        </div>
      </div>

      <!-- PTZ Controller -->
      <div class="col-lg-12" *ngIf="ts.controlType == '3'">
        <div class="">
          <div class="row">
            <div class="col-xs-12 ptz-home">
              <table class="ptz">
                <tr>
                  <td></td>
                  <td><button (click)="compass(ts, 'nw')" type="button" class="btn btn-sm btn-outline-default compass">NW</button></td>
                  <td><button (click)="compass(ts, 'n')" type="button" class="btn btn-sm btn-outline-default">N</button></td>
                  <td><button (click)="compass(ts, 'ne')" type="button" class="btn btn-sm btn-outline-default compass">NE</button></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td><button (click)="compass(ts, 'w')" type="button" class="btn btn-sm btn-outline-default">W</button></td>
                  <td>+</td>
                  <td><button (click)="compass(ts, 'e')" type="button" class="btn btn-sm btn-outline-default">E</button></td>
                </tr>
                <tr>
                  <td></td>
                  <td><button (click)="compass(ts, 'sw')" type="button" class="btn btn-sm btn-outline-default compass">SW</button></td>
                  <td><button (click)="compass(ts, 's')" type="button" class="btn btn-sm btn-outline-default">S</button></td>
                  <td><button (click)="compass(ts, 'se')" type="button" class="btn btn-sm btn-outline-default compass">SE</button></td>
                </tr>
              </table> 
            </div>
            <div class="col-xs-12 ptz-home">
              <table class="ptz">
                <tr>
                  <td></td>
                  <td></td>
                  <td><button (click)="control(ts, 'up',1)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-double-up"></i></button></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td><button (click)="control(ts, 'up',0.2)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-up"></i></button></td>
                </tr>

                <tr>
                  <td><button (click)="control(ts, 'left',1)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-double-left"></i></button></td>
                  <td><button (click)="control(ts, 'left',0.2)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-left"></i></button></td>
                  <td><button (click)="photo(ts)" type="button" class="btn btn-sm btn-outline-default"><i class="fa fa-camera"></i></button></td>
                  <td><button (click)="control(ts, 'right',0.2)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-right"></i></button></td>
                  <td><button (click)="control(ts, 'right',1)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-double-right"></i></button></td>
                  <!--<td><button (click)="control(ts, 'right',10)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-right"></i></button></td>-->
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td><button (click)="control(ts, 'down',0.2)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-down"></i></button></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td><button (click)="control(ts, 'down',1)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-double-down"></i></button></td>
                  <td></td>
                  <td></td>
                  <!--<td></td>-->
                </tr>
              </table>
            </div>
            <div class="col-12 ptz-home">
              <table class="ptz">
                <tr>
                  <td><button (click)="zoom(ts, 'in')" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-plus"></i></button></td>
                  <td><button (click)="zoom(ts, 'out')" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-minus"></i></button></td>
                  
                  <td><!--<button (click)="control(ts, 'down',10)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-down"></i></button>--></td>
                  <!--<td></td>-->
                  <td><button (click)="savePtz()" title="Save Current Location" type="button" class="btn btn-sm btn-outline-default"><i class="fa fa-save"></i></button></td>
                  <td><button (click)="loadPtz()" title="Open Saved Location" type="button" class="btn btn-sm btn-outline-default"><i class="fa fa-binoculars"></i></button></td>
                </tr>
                <tr>
                  <td colspan="3">Direction:</td>
                  <td colspan="3"><input type="number" class="form-control from-control-sm" [(ngModel)]="ptzDirection" title="Direction" min="0" max="359"></td>
                </tr>
                <tr>
                  <td colspan="3">Elevation:</td>
                  <td colspan="3"><input type="number" class="form-control from-control-sm" [(ngModel)]="ptzElevation" title="Elevation" min="-20" max="20"></td>
                </tr>
                <tr>
                  <td colspan="3">Zoom:</td>
                  <td colspan="3"><input type="number" class="form-control from-control-sm" [(ngModel)]="ptzZoom" title="Zoom" min="0" max="47"></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

 
    
  </div> 
</div> 